module.exports = require("@swa-ui/placements/src/AccordionBlock/AccordionBlock.module.scss");